// Author Lin
// Date 2021-11-06 10:21:09

class MintalMesMstPowerStationMeter {
    constructor({
            id = null,
            generatorSetId = '',
            generatorName = '',
            meterName = '',
            meterType = '',
            remark = ''}
    = {}) {
        this.id = id;
        this.generatorSetId = generatorSetId;
        this.generatorName = generatorName;
        this.meterName = meterName;
        this.meterType = meterType;
        this.remark = remark;
    }
    }
    
    function newEntity() {
    return new MintalMesMstPowerStationMeter();
    }
    
        function gridFields() {
        return Object.freeze([
            {
            key: 'id',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.id',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'generatorSetId',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.generatorSetId',
            sortable: true,
                isDetail: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'locationName',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.locationName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'generatorName',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.generatorName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'meterName',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.meterName',
            sortable: true,
            form: {
            type: 'input'
            }
            },
            {
            key: 'meterType',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.meterType',
            sortable: true,
            form: {
            type: 'select'
            ,options: [
                    { value: '1', text: '电表' },
                                { value: '2', text: '煤气表' },
                                { value: '3', text: '蒸汽表' },
                                { value: '4', text: '断路器表' }
                ]
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.grid.remark',
            sortable: true,
                isDetail: true,
            form: {
            type: 'textarea'
            }
            }
        ])}
    
    const filter = {
        idFilter : '',
        idListFilter : [],
        generatorSetIdFilter : '',
        generatorNameFilter : '',
        meterNameFilter : '',
        meterTypeFilter : ''
    };
    
    const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
    
    const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
    
    const filterConfigs = [
            {
            key: 'generatorNameFilter',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.filter.generatorName',
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstGeneratorSet'
                ,correspondingField: 'generatorCode'
                ,fieldsBindingByEntityModalSelected: '{"generatorSetId":"id"}'
                    }
            },
            {
            key: 'meterNameFilter',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.filter.meterName',
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'meterTypeFilter',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.filter.meterType',
            disabled: false,
            form: {
            type: 'select'
                ,showLabelSelectOne: true
             ,options: [
                    { value: '1', text: '电表' },
                    { value: '2', text: '煤气表' },
                    { value: '3', text: '蒸汽表' },
                    { value: '4', text: '断路器表' }
                ]
            }
            }
    ];
    
    
        const entityFormConfigs = [
            {
            key: 'generatorName',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.entity.generatorName',
            sortable: true,
            disabled: false,
            form: {
            type: 'entityModalSelect'
                ,entity: 'mintalMesMstGeneratorSet'
                ,correspondingField: 'generatorCode'
                ,fieldsBindingByEntityModalSelected: '{"generatorSetId":"id"}'
                    }
            },
            {
            key: 'meterName',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.entity.meterName',
            sortable: true,
            disabled: false,
            form: {
            type: 'input'
                    }
            },
            {
            key: 'meterType',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.entity.meterType',
            sortable: true,
            disabled: false,
            form: {
            type: 'select'
                ,showLabelSelectOne: true
            ,options: [
                    { value: '1', text: '电表' },
                    { value: '2', text: '煤气表' },
                    { value: '3', text: '蒸汽表' },
                    { value: '4', text: '断路器表' }
                ]
            }
            },
            {
            key: 'remark',
            label: 'label.mintal.mst.mintalMesMstPowerStationMeter.entity.remark',
            sortable: true,
            disabled: false,
            form: {
            type: 'textarea'
                    }
            }
    ]
    
    export {MintalMesMstPowerStationMeter, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs
    
    
    }
    